export interface Vault {
  epoch: string;
  ozkEarned: number;
  ozkStaked: number;
  apr: string;
  endsIn: string;
  action: string;
  stakingContract: string | undefined;
  yieldContract: string | undefined;
}

export const VaultsConfig = {
  vaults: [
    {
      epoch: '14 days',
      ozkEarned: 0,
      ozkStaked: 0,
      apr: 'N/A',
      endsIn: 'N/A',
      action: 'Stake',
      stakingContract: process.env.REACT_APP_14_DAY_STAKING_CONTRACT,
      yieldContract: process.env.REACT_APP_14_DAY_YIELD_CONTRACT,
    },
    {
      epoch: '30 days',
      ozkEarned: 0,
      ozkStaked: 0,
      apr: 'N/A',
      endsIn: 'N/A',
      action: 'Stake',
      stakingContract: process.env.REACT_APP_30_DAY_STAKING_CONTRACT,
      yieldContract: process.env.REACT_APP_30_DAY_YIELD_CONTRACT,
    },
    {
      epoch: '90 days',
      ozkEarned: 0,
      ozkStaked: 0,
      apr: 'N/A',
      endsIn: 'N/A',
      action: 'Stake',
      stakingContract: process.env.REACT_APP_90_DAY_STAKING_CONTRACT,
      yieldContract: process.env.REACT_APP_90_DAY_YIELD_CONTRACT,
    },
  ],
};
